import { useState } from "react";
import type { NativeCredentials } from "../api";
import { Button } from "./ui/Button";
import { CopyField } from "./ui/CopyField";
import { Dialog } from "./ui/Dialog";
import { Icon } from "./ui/Icon";

interface CredentialDialogProps {
  readonly credentials: NativeCredentials;
  readonly onClose: () => void;
}

export function CredentialDialog({ credentials, onClose }: CredentialDialogProps) {
  const [confirmed, setConfirmed] = useState(false);
  return (
    <Dialog
      busy={!confirmed}
      description="关闭后平台无法再次查看；遗失时只能轮换。不得放入 App、浏览器或 Git。"
      eyebrow="ONE-TIME SECRET"
      size="large"
      title="立即保存 AppSecret"
      onClose={onClose}
    >
      <div className="credential-content">
        <div className="credential-alert"><Icon name="key" /><div><strong>仅展示一次</strong><p>请立即保存到服务端密钥管理系统，客户端不得持有 AppSecret。</p></div></div>
        <div className="copy-field-grid"><CopyField label="AppKey" value={credentials.appKey} /><CopyField label="管理员 userID" value={credentials.adminUserId} /><CopyField label="REST API Domain" value={credentials.restApiDomain} /><CopyField label="密钥版本" value={`v${credentials.keyVersion}`} /></div>
        <CopyField label="AppSecret" sensitive value={credentials.appSecret} />
        <label className="confirmation-control"><input type="checkbox" checked={confirmed} onChange={(event) => { setConfirmed(event.currentTarget.checked); }} /><span><strong>我已安全保存 AppSecret</strong><small>确认后才能关闭此窗口</small></span></label>
      </div>
      <footer className="dialog-actions"><Button disabled={!confirmed} variant="primary" onClick={onClose}>确认并关闭</Button></footer>
    </Dialog>
  );
}
